import { EDropCategory } from '../../../data/Constants';
import SplitBar from '../SplitBar';
import { DroppableZone } from './DroppableZone';
import { CategoryTree } from './CategoryTree';

import type { RefObject } from 'react';
import type { IFeatureFamily, ISection } from '../../../../types';

interface ICategoryPanesProps {
  editDataView: boolean;
  expanded: string[];
  globalUnassignedItems: IFeatureFamily[];
  handleAddSection: (parent?: ISection | null) => void;
  handleDeleteSection: (section: ISection) => void;
  handleRemoveItem: (itemCode: string) => void;
  isValidDragItem: boolean;
  overId: string | null;
  paneRefs: RefObject<HTMLDivElement[]>;
  resizeHandler: (newWidths: number[]) => void;
  sections: ISection[];
  selectedSection: ISection | null;
  selectedSectionId: string | null;
  setExpanded: React.Dispatch<React.SetStateAction<string[]>>;
  setPaneRef: (index: number) => (element: HTMLDivElement | null) => void;
  setSelectedSectionId: React.Dispatch<React.SetStateAction<string | null>>;
  t: (key: string) => string;
}

export const CategoryPanes: React.FC<ICategoryPanesProps> = ({
  editDataView,
  expanded,
  globalUnassignedItems,
  handleAddSection,
  handleDeleteSection,
  handleRemoveItem,
  isValidDragItem,
  overId,
  paneRefs,
  resizeHandler,
  sections,
  selectedSection,
  selectedSectionId,
  setExpanded,
  setPaneRef,
  setSelectedSectionId,
  t,
}) => (
  <div className="category-content">
    <section ref={setPaneRef(0)} className="left-pane pane resize-hor">
      <div className="categories-list">
        <CategoryTree
          editDataView={editDataView}
          expanded={expanded}
          handleAddSection={handleAddSection}
          handleDeleteSection={handleDeleteSection}
          sections={sections}
          selectedSectionId={selectedSectionId}
          setExpanded={setExpanded}
          setSelectedSectionId={setSelectedSectionId}
        />
      </div>
    </section>
    <SplitBar index={0} paneRefs={{ current: paneRefs.current }} onResize={resizeHandler} />
    <section
      ref={setPaneRef(1)}
      className={
        editDataView ? 'resize-hor middle-pane pane' : 'resize-hor middle-pane disabled-view pane'
      }
    >
      <div className="assigned-section-header">{t('labels.assigned')}</div>
      <DroppableZone
        id={EDropCategory.Assigned}
        items={selectedSection?.contents || []}
        isSortable={true}
        onRemove={handleRemoveItem}
        itemType={selectedSection?.type}
        isValidDragItem={isValidDragItem}
        overId={overId === EDropCategory.Assigned}
        containerType={EDropCategory.Assigned}
        isEditMode={editDataView}
      />
    </section>
    <SplitBar index={1} paneRefs={{ current: paneRefs.current }} onResize={resizeHandler} />
    <section
      ref={setPaneRef(2)}
      className={
        editDataView ? 'right-pane resize-hor pane' : 'resize-hor right-pane disabled-view pane'
      }
    >
      <div className="unassingned-section-header">{t('labels.unassigned')}</div>
      <DroppableZone
        id={EDropCategory.Unassigned}
        items={globalUnassignedItems}
        isSortable={false}
        overId={overId === EDropCategory.Unassigned}
        containerType={EDropCategory.Unassigned}
        isEditMode={editDataView}
      />
    </section>
  </div>
);
